import deansList1st from '@assets/certifications/Deans_lister_1st_sem_2024_2025.png'
import deansList2nd from '@assets/certifications/Deans_lister_2nd_sem_2024_2025.png'
import certAward2017 from '@assets/certifications/cert_of_award_2017-2018.png'
import certRecog2018 from '@assets/certifications/cert_of_recognition_2018-2019.png'
import certRecog2018Alt from '@assets/certifications/cert_of_recognition_2018_2019.png'
import certRecog4thQ from '@assets/certifications/cert_of_recognition_4th_quarter_2018_2019.png'
import sololearnCert from '@assets/certifications/sololearn_cert.png'

export const certifications = [
  {
    id: 1,
    name: 'Dean\'s Lister - 1st Semester',
    issuer: 'University of Cebu',
    year: '2024-2025',
    image: deansList1st
  },
  {
    id: 2,
    name: 'Dean\'s Lister - 2nd Semester',
    issuer: 'University of Cebu',
    year: '2024-2025',
    image: deansList2nd
  },
  {
    id: 3,
    name: 'Certificate of Award',
    issuer: 'San Agustin National High School',
    year: '2017-2018',
    image: certAward2017
  },
  {
    id: 4,
    name: 'Certificate of Recognition',
    issuer: 'San Agustin National High School',
    year: '2018-2019',
    image: certRecog2018
  },
  {
    id: 5,
    name: 'Certificate of Recognition - 4th Quarter',
    issuer: 'San Agustin National High School',
    year: '2018-2019',
    image: certRecog4thQ
  },
  {
    id: 6,
    name: 'Sololearn Certification',
    issuer: 'Sololearn',
    year: '2024',
    image: sololearnCert
  }
]
